// src/admin/components/Button.tsx
// Button variants follow the design system exactly:
//   primary — solid cobalt fill (default; main page action)
//   secondary — bordered surface (cancel, secondary action)
//   ghost — no border (toolbar, "more" buttons)
//   outline — cobalt border, light fill on hover (tertiary brand action)
//   danger / success — semantic solid fills for irreversible actions
import type { ButtonHTMLAttributes, ReactNode } from 'react';
import styles from './Button.module.css';

type Variant = 'primary' | 'secondary' | 'ghost' | 'outline' | 'danger' | 'success';
type Size = 'sm' | 'md' | 'lg';

interface Props extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: Variant;
  size?: Size;
  leftIcon?: ReactNode;
  rightIcon?: ReactNode;
  loading?: boolean;
}

export default function Button({
  variant = 'primary',
  size = 'md',
  leftIcon,
  rightIcon,
  loading,
  children,
  className,
  disabled,
  type = 'button',
  ...rest
}: Props) {
  const cls = [styles.btn, styles[variant], styles[size], className]
    .filter(Boolean).join(' ');
  return (
    <button {...rest} type={type} disabled={disabled || loading} className={cls}>
      {leftIcon && <span className={styles.icon}>{leftIcon}</span>}
      <span>{loading ? 'Working…' : children}</span>
      {rightIcon && <span className={styles.icon}>{rightIcon}</span>}
    </button>
  );
}
